import type { ResolveFn } from '../types.js';

const HORN_RATIO: Record<number, number> = { 2: 30, 3: 15, 11: 15, 12: 30 };

export const resolveHorn: ResolveFn = (b, roll) => {
  const ratio = HORN_RATIO[roll.total];
  if (ratio === undefined) {
    return { betId: b.id, outcome: 'lose', payout: 0 };
  }
  const part = Math.floor(b.amount / 4);
  const others = b.amount - part;
  return { betId: b.id, outcome: 'win', payout: part * ratio - others };
};

export const resolveWorld: ResolveFn = (b, roll) => {
  const ratio = HORN_RATIO[roll.total];
  const part = Math.floor(b.amount / 5);
  const others = b.amount - part;
  if (ratio !== undefined) {
    return { betId: b.id, outcome: 'win', payout: part * ratio - others };
  }
  if (roll.total === 7) {
    const win = part * 4 - others;
    return win === 0
      ? { betId: b.id, outcome: 'push', payout: 0 }
      : { betId: b.id, outcome: 'win', payout: win };
  }
  return { betId: b.id, outcome: 'lose', payout: 0 };
};

export const resolveHop: ResolveFn = (b, roll) => {
  if (!b.hopFaces) throw new Error('hop bet missing hopFaces');
  const [a, c] = b.hopFaces;
  const matches = (roll.d1 === a && roll.d2 === c) || (roll.d1 === c && roll.d2 === a);
  if (!matches) return { betId: b.id, outcome: 'lose', payout: 0 };
  const ratio = a === c ? 30 : 15;
  return { betId: b.id, outcome: 'win', payout: b.amount * ratio };
};
